import { computed } from 'vue';

import { SOURCE_STATUS_MAP } from '@/constants/data_sources';
import { MDM_TYPES } from '@/constants/mdm';
import { useSourcesStore } from '@/stores';
import type { Source, SourceField } from '@/types/sources';

const [DELETING_STATUS] = SOURCE_STATUS_MAP.deleting;

export function useAccountProductSource(feedId: () => number | undefined) {
  const sourcesStore = useSourcesStore();

  const accountProductSource = computed<Source | undefined>(() => {
    const id = feedId();
    if (id == null) return undefined;
    return sourcesStore
      .getSourcesByFeedId(id)
      .find(
        (source) =>
          source.mdm_type === MDM_TYPES.ACCOUNT_PRODUCT &&
          source.status !== DELETING_STATUS,
      );
  });

  const fieldsByMdmProperty = computed<Record<string, SourceField>>(() => {
    const fields = accountProductSource.value?.fields ?? [];
    return Object.fromEntries(
      fields
        .filter((field) => Boolean(field.mdm_property))
        .map((field) => [field.mdm_property, field]),
    );
  });

  const lockedColumns = computed<string[]>(() =>
    Object.values(fieldsByMdmProperty.value).map((field) => field.column),
  );

  return {
    accountProductSource,
    fieldsByMdmProperty,
    lockedColumns,
  };
}
